export default "__VITE_ASSET__BU4s$ml7__"